import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface RevisionMediaSkeletonProps {
  count?: number;
  className?: string;
}

const RevisionMediaSkeleton = ({
  count = 1,
  className,
}: RevisionMediaSkeletonProps) => {
  return (
    <div
      className={classNames(
        styles.sectionContainer,
        "flex flex-col md:gap-5 gap-4 mt-3",
        className,
      )}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={classNames(styles.accordionSkeleton)}>
          <div className={classNames(styles.accordionHeader)}>
            <div className={classNames(styles.headerContent)}>
              <SkeletonLoader className={styles.titleSkeleton} />
              <SkeletonLoader className={styles.badgeSkeleton} />
            </div>
          </div>

          <div
            className={classNames(
              styles.accordionContent,
              "flex flex-col gap-4",
            )}
          >
            <div className={classNames(styles.filesGridSkeleton)}>
              {Array.from({ length: 6 }).map((_, fileIndex) => (
                <div
                  key={fileIndex}
                  className={classNames(styles.fileThumbnailSkeleton)}
                >
                  <SkeletonLoader className={styles.fileImageSkeleton} />
                  <SkeletonLoader className={styles.fileNameSkeleton} />
                </div>
              ))}
            </div>

            <div
              className={classNames(
                styles.downloadButtonsSkeleton,
                "flex gap-3",
              )}
            >
              <SkeletonLoader className={styles.downloadButtonSkeleton} />
              <SkeletonLoader className={styles.downloadButtonSkeleton} />
            </div>

            <div className={classNames(styles.metadataSkeleton)}>
              <div className={classNames(styles.metadataItemSkeleton)}>
                <SkeletonLoader className={styles.metadataIconSkeleton} />
                <SkeletonLoader className={styles.metadataTextSkeleton} />
              </div>
              <div className={classNames(styles.metadataItemSkeleton)}>
                <SkeletonLoader className={styles.metadataIconSkeleton} />
                <SkeletonLoader className={styles.metadataTextSkeleton} />
              </div>
              <div className={classNames(styles.metadataItemSkeleton)}>
                <SkeletonLoader className={styles.metadataIconSkeleton} />
                <SkeletonLoader className={styles.metadataTextSkeleton} />
              </div>
              <SkeletonLoader className={styles.statusBadgeSkeleton} />
            </div>

            <div className={classNames(styles.commentsSectionSkeleton)}>
              <SkeletonLoader className={styles.commentTitleSkeleton} />
              <SkeletonLoader className={styles.commentTextSkeleton} />
              <SkeletonLoader className={styles.commentTextSkeleton} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RevisionMediaSkeleton;
